import React from "react";
import { ArrowLeftIcon, ArrowRightIcon } from "@heroicons/react/24/outline";
import { useTranslation } from "react-i18next";
import { twMerge } from "tailwind-merge";

import type { Styled } from "~/utils";
import { PageButtons } from "./PageButtons";

interface PaginationControlsProps extends Styled {
  currentPage: number;
  numPages: number;
  setPage: (p: number) => void;
}

export const PaginationControls = ({
  currentPage,
  numPages,
  setPage,
  className,
}: PaginationControlsProps) => {
  const { t } = useTranslation();

  return (
    <nav className={twMerge("flex w-full flex-row justify-between", className)}>
      <button
        className="flex flex-row items-center gap-1.5 p-1 text-neutral-variant-40 hover:opacity-80 disabled:opacity-40 dark:text-neutral-variant-80"
        onClick={() => setPage(currentPage - 1)}
        disabled={currentPage === 1 || numPages === 0}
        aria-label={t("general.previous")}
      >
        <ArrowLeftIcon className="h-5 w-5" />
        <span>{t("tables.prev")}</span>
      </button>
      <PageButtons
        currentPage={currentPage}
        numPages={numPages}
        setPage={setPage}
      />
      <button
        className="flex flex-row items-center gap-1.5 p-1 text-neutral-variant-40 hover:opacity-80 disabled:opacity-40 dark:text-neutral-variant-80"
        onClick={() => setPage(currentPage + 1)}
        disabled={currentPage === numPages || numPages === 0}
      >
        <span>{t("tables.next")}</span>
        <ArrowRightIcon className="h-5 w-5" />
      </button>
    </nav>
  );
};
